// Time grouping for the dashboard. The dashboard always shows ALL data; this
// selects how the trend/payments series are bucketed. The API takes the key as a
// `grain` query param and returns pre-formatted bucket labels.

export type Grain = 'day' | 'week' | 'month' | 'quarter' | 'year';

export const GRAINS: Array<{ key: Grain; label: string }> = [
  { key: 'day', label: 'Day' },
  { key: 'week', label: 'Week' },
  { key: 'month', label: 'Month' },
  { key: 'quarter', label: 'Quarter' },
  { key: 'year', label: 'Year' },
];
